import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@mui/material';
import { MenuWithId } from 'components';
import { useTranslation } from 'react-i18next';
import { useEvents } from 'hooks';
import _ from 'lodash';

const LayerIdentityFilter = ({ devices, fields, properties }) => {
  const { t } = useTranslation();
  const { setFilter, filters } = useEvents();

  let source = [{ id: 0, name: 'None' }];
  if (filters?.layer?.toLowerCase() === 'device') {
    source = source.concat(
      _.map(devices, (device) => {
        return {
          id: device.id,
          name: device.name ? device.name : device.hw_address?.slice(device.hw_address.length - 5),
        };
      })
    );
  } else if (filters?.layer?.toLowerCase() === 'field') {
    source = source.concat(fields);
  } else if (filters?.layer?.toLowerCase() === 'property') {
    source = source.concat(properties);
  }

  const everything = [].concat(devices, fields, properties);

  const selected = _.find(everything, { id: filters?.layer_id });

  return (
    <Grid item xs={12} md={12} lg={12}>
      <Typography>{t('layer_id')}</Typography>
      <MenuWithId
        placeholder={t('layer_id')}
        label={t('layer_id')}
        menuItems={source ?? [{ id: 0, name: 'None' }]}
        disabled={!filters?.layer_id}
        selectedItem={selected?.name ? selected.name : selected?.hw_address?.slice(selected.hw_addres.length - 5)}
        selectItem={(item) => setFilter({ layer_id: item.id === 0 ? '' : item.id })}
        inputProps={{
          maxLength: 24,
        }}
        size="normal"
      />
    </Grid>
  );
};

LayerIdentityFilter.propTypes = {
  devices: PropTypes.array,
  fields: PropTypes.array,
  properties: PropTypes.array,
};

LayerIdentityFilter.defaultProps = {
  devices: [],
  fields: [],
  properties: [],
};

export default LayerIdentityFilter;
